;(function($, undefined){

    var rnn = window.rnn;

    var loading = {
        start: function($link) {
            $link
                .data('real-href', $link.attr('href'))
                .attr('href', '#')
                .button('loading');
        },
        stop: function($link) {
            $link
                .attr('href', $link.data('real-href'))
                .button('reset');
        }
    };

    $.niceTrunc = function(str, maxChars) {
        if (str.length <= maxChars) {
            return str;
        }
        var maxFit = maxChars - 3;
        var truncateAt = str.lastIndexOf(' ', maxFit);
        if (truncateAt == -1 || truncateAt < maxChars / 2) {
            truncateAt = maxFit;
        }
        return str.substr(0, truncateAt) + "...";
    };

    function createMREC(articleOptions) {
        return $.el.article(
            articleOptions,
            $.el.div(
                {'class': 'adGroup adGroupLabel'},
                $.el.div(
                    {'class': 'adSpace', id: 'adSpace1'},
                    $.el.img(
                        {width: '300', height: '268'}
                    )
                )
            )
        );
    }

    function createResult(result, articleOptions){
        var isVideo, isGallery, isImageForSale = false;
        if (result.type == 'video'){ isVideo = true; }
        if (result.type == 'photogallery'){ isGallery = true; }
        if (result.type == 'image'){ isImageForSale = true; }
        return $.el.article(
            articleOptions,
            $.el.a(
                {
                    href: result.url
                },
                result.for_sale_valid && $.el.span({'class': 'photoSalesLink', title: 'This image is for sale'},
                    $.el.i({'class':'icomoon-icon icon-coin-dollar'})
                ),
                isVideo && $.el.span({'class': 'playOverlay'}),
                result.image && $.el.img(
                    {
                        src: result.image.replace(/^(.*)\.(.+?)$/, '$1_t312.$2'),
                        width: '312'
                    }
                ),
                $.el.h4(
                    (result.title && $.el.span($.niceTrunc(result.title,50))),
                    (result.date && $.el.small(result.date)),
                    $.el.div({'class':'buyNow'},
                        $.el.span(
                            (isImageForSale ? "Buy now " : (isGallery ? "View gallery " : "View " + result.type + " ")),
                            $.el.i({'class':'tangram-icon icon-arrow-right-thick'})
                        )
                    )
                )
            )
        );
    }

    function clickViewMore(event) {

        var $link = $(this),
            $target = $link.closest('.search-results').find('.results'),
            itemClasses = $target.data('item-classes'),
            existingUrls = $target.data('existing-urls');

        event.preventDefault();

        $.ajax({
            dataType: 'json',
            beforeSend: function(jqXHR, settings) {
                var url = $link.attr('href');
                if (url === '#') {
                    // It is alreading fetching more,
                    // so don't make another request.
                    return false;
                } else {
                    loading.start($link);
                    settings.url = url + '&format=json';
                }
            },
            success: function(data) {
                if (data.results) {
                    $.each(data.results, function(index, result) {
                        var articleOptions = {'class': itemClasses};
                        if (existingUrls[result.url] !== true) {
                            if (result.for_sale_valid) {
                                articleOptions['class'] += ' for-sale';
                            }
                            /* Experiment: Dynamic MREC loading */
                            // if (rnn.site.network.isAU && index === 4) {
                            //     $target.append(
                            //         createMREC(articleOptions)
                            //     );
                            // }
                            $target.append(
                                createResult(result, articleOptions)
                            );
                            existingUrls[result.url] = true;
                        }
                    });
                }

                if (data.next_url) {
                    $link.data('real-href', data.next_url);
                } else {
                    $link.replaceWith(
                        $.el.p("You've reached the end!")
                    );
                }

            },
            error: function(jqXHR, textStatus, errorThrown) {
                var errorMessage;
                if (jqXHR.getResponseHeader('content-type') === 'application/json') {
                    try {
                        errorMessage = $.parseJSON(jqXHR.responseText).error;
                    } catch (error) {}
                }
                alert(errorMessage || errorThrown || 'There was a problem.');
            },
            complete: function() {
                loading.stop($link);
                if ($target.hasClass('masonry')) {
                    $target.masonry('reload'); //this is to ensure that masonry results work in ie8.
                }
            }
        });

        if (existingUrls === undefined) {
            // Store all existing result URLs, so we can prevent duplicate
            // results when new content is published. Existing results get
            // pushed down from one page to the next, and so they would
            // show up twice.
            existingUrls = {};
            $target.find('article a').each(function(){
                existingUrls[$(this).attr('href')] = true;
            });
            $target.data('existing-urls', existingUrls);
        }

    }

    function simpleSearchTypeField() {
        var $select, $optionAll, $optionPhotos, $optionVideos,
            $widget, $widgetPhotos, $widgetVideos;

        $select = $(this);
        $optionAll = $select.find('#search_type_all');
        $optionPhotos = $select.find('#search_type_photos');
        $optionVideos = $select.find('#search_type_videos');

        $widget = $($.el.div(
            {'class': 'btn-group','data-toggle' :'buttons-checkbox'},
            $.el.button(
                {'type': 'button', 'class': 'btn btn-large searchTypeWidgetPhotos', 'title': 'Photos'},
                $.el.i({'class': 'icon-camera'})
            ),
            $.el.button(
                {'type': 'button', 'class': 'btn btn-large searchTypeWidgetVideos', 'title': 'Videos'},
                $.el.i({'class': 'icon-facetime-video'})
            )
        ));

        $widgetPhotos = $widget.find('.searchTypeWidgetPhotos');
        $widgetVideos = $widget.find('.searchTypeWidgetVideos');

        if ($optionAll.is(':selected') || $optionPhotos.is(':selected')) {
            $widgetPhotos.button('toggle');
        }

        if ($optionAll.is(':selected') || $optionVideos.is(':selected')) {
            $widgetVideos.button('toggle');
        }

        $widget
        .on('click', 'button', function (event) {
            // Push handler to event loop to allow 'active' class to be applied
            setTimeout(function () {
                var isPhotosToggled, isVideosToggled;

                isPhotosToggled = $widgetPhotos.is('.active');
                isVideosToggled = $widgetVideos.is('.active');

                if (isPhotosToggled && isVideosToggled) {
                    $select.val($optionAll.val());
                } else if (isPhotosToggled) {
                    $select.val($optionPhotos.val());
                } else if (isVideosToggled) {
                    $select.val($optionVideos.val());
                } else {
                    $select.val($optionAll.val());
                }
            }, 0);
        });

        $select.after($widget).hide();

    }

    function initSimpleSearchTypeFields() {
        $('.simpleSearchForm #search_type').each(simpleSearchTypeField);
    }

    function initSearchForms() {
        $('[data-typeahead-urls]').each(function() {

            var $searchForm = $(this),
                typeaheadUrls = $searchForm.data().typeaheadUrls,
                categoriesUrl = typeaheadUrls && typeaheadUrls.categories,
                locationsUrl = typeaheadUrls && typeaheadUrls.locations,
                hatSearch = $('.hat-search'),
                hatSearchAction = hatSearch.attr('action'),
                $mobileSearch = $('.generalSearchForm'),
                $mobileSearchAction = $mobileSearch.attr('action'),
                tagsUrl = typeaheadUrls && typeaheadUrls.tags;

            categoriesUrl && $.getJSON(categoriesUrl, function (data) {
                // Initialise 'q' field typeahead using categories
                $searchForm.find('[name=q]').typeahead({
                    source: _.keys(data.category_name__id)
                });
                // Auto-fill a form's hidden 'cid' field it before submits, if possible
                $searchForm.bind('submit', function () {
                    var $form = $(this);
                    var key = $form.find('[name=q]').val();
                    $form.find('[name=cid]').val(data.category_name__id[key] || '');
                });
            });

            locationsUrl && $.getJSON(locationsUrl, function (data) {
                // Initialise 'in' field typeahead using regions/locations (including postcodes)
                $searchForm.find('[name=in]').typeahead({
                    source: _.union(
                        _.keys(data.region_name__id),
                        _.keys(data.location_name__id),
                        _.keys(data.location_postcode__id)
                    )
                });
                // Auto-fill a form's hidden 'rid' & 'lid' fields before it submits, if possible
                $searchForm.bind('submit', function () {
                    var $form = $(this),
                        useMyLocation = $form.find('.useMyLocation'),
                        key = $form.find('[name=in]').val(),
                        regionId = data.region_name__id[key];


                    key && $form.find('[name=rid]').val(regionId || '');

                    if(useMyLocation.is('.on')){
                        getLocation(function(position){setLocationFields($form, position);}, function(){noLocationError($form);});
                    }

                    if (!regionId) {
                        $form.find('[name=lid]').val(data.location_name__id[key] || data.location_postcode__id[key] || '');
                    }
                });
            });

            tagsUrl && $.getJSON(tagsUrl, function (data) {
                // Initialise 'keywords' field typeahead using tags
                $searchForm.find('[name=keywords]')
                    .typeahead({
                        source: data,
                        autoSelect: false,
                        updater: function(item) {
                            if(hatSearchAction) {
                                window.location = hatSearchAction + "?keywords=" + item;
                            }
                            if($mobileSearchAction) {
                                // User is on the Mobile search results page
                                window.location = $mobileSearchAction + "?keywords=" + item;
                            }
                            return item;
                        }
                    })
                    .keydown(function (event) {
                        if (event.which === 13) {
                            $searchForm.submit();
                        }
                    });
            });

            hatSearch.on('submit', function(e) {
                e.preventDefault();
            });

        });
    }

    function initSearch() {
        initSimpleSearchTypeFields();
        initSearchForms();
        $(document).on('click', '.search-results .view-more a', clickViewMore);
    }

    rnn.modules.register('search', {
        init: initSearch
    });

})(jQuery);
